<template>
    <div class="flex-grow-1" :class="{'merlin-asset-border': item.value && isMerlinMedia(item.value)}">
        <div v-if="item.value && isMerlinMedia(item.value)" class="merlin-asset-wrapper">
            <span class="merlin-asset-warning">
                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                Merlin Asset
            </span>
        </div>
        <div class="d-flex align-items-center">
            <div class="flex-grow-1 mr-3">
                <div class="d-flex align-items-center">
                    <div v-if="item.value" class="mr-2">
                        <div v-if="item.type === 'audio'">
                            <b-link :href="item.value" target="_blank">
                                <b-img
                                    :src="'https://cdn.studiesweekly.com/online/resources/pod_media/audio_default.png'"
                                    width="75"
                                    height="auto"
                                    class="p-0"
                                    thumbnail
                                />
                            </b-link>
                        </div>
                        <div v-else-if="item.type === 'video'">
                            <b-link :href="item.value" target="_blank">
                                <b-img
                                    v-if="item.splash_url"
                                    :src="item.splash_url"
                                    width="75"
                                    height="auto"
                                    class="p-0"
                                    thumbnail
                                />
                                <b-img
                                    v-else
                                    :src="'https://cdn.studiesweekly.com/online/resources/pod_media/video_default.png'"
                                    width="75"
                                    height="auto"
                                    class="p-0"
                                    thumbnail
                                />
                            </b-link>

                        </div>

                        <div v-else-if="item.type === 'pdf'">
                            <div class="small">
                                <CardID :id="item.printable_id" type="Printable" class="mb-2" />
                            </div>
                            <div style="text-align: center;">
                                <b-link :href="item.value" target="_blank">
                                    <font-awesome-icon :icon="['far', 'file-pdf']" size="3x" />
                                </b-link>
                            </div>
                        </div>
                        <div v-else-if="item.type === 'image'">
                            <b-link :href="item.value" target="_blank">
                                <b-img
                                    v-if="item.splash_url"
                                    :src="item.splash_url"
                                    width="75"
                                    height="auto"
                                    class="p-0"
                                    thumbnail
                                />
                                <b-img
                                    v-else
                                    :src="item.value"
                                    width="75"
                                    height="auto"
                                    class="p-0"
                                    thumbnail
                                />
                            </b-link>
                        </div>
                        <div v-else-if="item.type === 'link'">
                            <b-img
                                :src="item.src"
                                width="75"
                                height="auto"
                                class="p-0"
                                thumbnail
                            />
                        </div>

                        <div v-else>
                            <b-link :href="item.value" target="_blank">
                                <b-img
                                    v-if="item.splash_url"
                                    :src="item.splash_url"
                                    width="75"
                                    height="auto"
                                    class="p-0"
                                    thumbnail
                                />
                                <font-awesome-icon v-else :icon="['far', 'image']" size="3x" />
                            </b-link>
                        </div>
                    </div>

                    <div class="flex-grow-1 mr-3">
                        <template v-if="item.type !== 'link'">
                            <Title
                                v-if="item.name"
                                v-model="item.name"
                                :variant="'light'"
                                @update="updateTitle"
                                :disabled="disabled"
                            />
                        </template>
                        <template v-else>
                            <Title
                                v-if="item.name"
                                v-model="item.name"
                                :variant="'light'"
                                @update="updateTitle"
                                prefix_label="Name"
                                :disabled="disabled"
                            />
                            <Title
                                v-if="item.type === 'link'"
                                v-model="item.value"
                                :variant="'light'"
                                @update="updateLink"
                                prefix_label="URL"
                                :disabled="disabled"
                            />

                        </template>
                    </div>

                    <div>
                        <b-badge variant="secondary">
                            <span v-if="item.type === 'video'">
                                <font-awesome-icon :icon="['fad', 'video']" fixed-width /> Video
                            </span>
                            <span v-if="item.type === 'audio'">
                                <font-awesome-icon :icon="['fad', 'volume']" fixed-width /> Audio
                            </span>
                            <span v-if="item.type === 'image'">
                                <font-awesome-icon :icon="['fad', 'image']" fixed-width /> Image
                            </span>
                            <span v-if="item.type === 'pdf'">
                                <font-awesome-icon :icon="['fad', 'file-pdf']" fixed-width /> PDF
                            </span>
                            <span v-if="item.type === 'link'">
                                <font-awesome-icon :icon="['fad', 'link']" fixed-width /> Link
                            </span>
                            <span v-if="item.type === 'sims'">
                                <font-awesome-icon :icon="['fad', 'code']" fixed-width /> Sims
                            </span>
                        </b-badge>
                    </div>
                </div>
            </div>

            <div class="mr-3 d-flex text-left flex-column">
                <div class="flag-container">
                    <div class="d-flex align-items-center text-uppercase">
                        <div class="mr-1">
                            <span v-if="item.language == 'en' || item.language == 'us'">
                                <flag iso="us" />
                            </span>
                            <span v-if="item.language == 'es' || item.language == 'sp'">
                                <flag iso="es" />
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ml-auto">
                <b-dropdown
                    size="sm"
                    variant="secondary"
                    dropleft
                >
                    <template #button-content>
                        <font-awesome-icon :icon="['fad', 'cog']" />
                    </template>
                    <b-dropdown-item
                        v-if="item.type !== 'pdf'"
                        @click="editItem"
                        :disabled="!can_update_panel || disabled"
                    >
                        <font-awesome-icon :icon="['fad', 'edit']" class="text-primary" fixed-width /> Edit
                    </b-dropdown-item>
                    <b-dropdown-item
                        @click="deleteMediaItem"
                        :disabled="!can_update_panel || disabled"
                    >
                        <font-awesome-icon :icon="['fas', 'trash']" class="text-danger" fixed-width/> Delete
                    </b-dropdown-item>
                </b-dropdown>
            </div>
        </div>

        <related-media-item-modal
            v-model="show_related_media_item_modal"
            :item="item"
            @update="saveItem"
            @hide="show_related_media_item_modal = false"
        />

    </div>
</template>

<style lang="scss" scoped>
    .flag-container {
        min-width: 20px;
        min-height: 24px;
    }
</style>

<script>
import { mapState } from 'vuex'
import Title from '@/components/Title'
import RelatedMediaItemModal from '@/components/modals/article/related_media/RelatedMediaItemModal'
import CardID from '@/components/CardID'

export default {
    data: () => ({
        show_related_media_item_modal: false,
    }),
    props: [
        'publication',
        'article',
        'item',
        'type',
        'unit',
        'panel',
        'disabled',
    ],
    components: {
        Title,
        RelatedMediaItemModal,
        CardID
    },
    computed: {
        ...mapState({
            user: state => state.user.user
        }),
        can_update_panel(){
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'update_panel');
        }
    },
    methods: {
        saveItem(updates) {
            let updatedMediaItem = this.item
            for (const key in updates) {
                // Check if the key exists in the updatedMediaItem
                if (Object.prototype.hasOwnProperty.call(updatedMediaItem, key)) {
                // Update the value using this.$set
                this.$set(updatedMediaItem, key, updates[key]);
                }
            }
            this.$emit('updateMediaItem', updatedMediaItem)
        },
        editItem () {
            this.show_related_media_item_modal = true
        },
        updateTitle (title) {
            let updatedMediaItem = this.item

            updatedMediaItem.name = title
            this.$emit('updateTitle', updatedMediaItem)
        },
        updateLink(link) {
            let updatedMediaItem = this.item

            updatedMediaItem.value = link
            this.$emit('updateLink', updatedMediaItem)
        },
        deleteMediaItem() {
            this.$swal({
                html: 'Are you sure you want to remove this media from the panel?',
                showCancelButton: true,
                confirmButtonText: 'Remove Media',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.$emit('deleteMediaItem')
                }
            })

        },
        setMediaType() {
            if (this.item && this.item.value && !this.item.type) {

                // Add a default protocol if the URL starts with '//'
                const urlWithProtocol = this.item.value.startsWith('//') ? `https:${this.item.value}` : this.item.value;
                const url = new URL(urlWithProtocol);
                const pathWithoutQuery = url.pathname; // Get the path without query parameters
                const lastDotIndex = pathWithoutQuery.lastIndexOf('.');

                if (lastDotIndex === -1) return

                const fileExtension = pathWithoutQuery.slice(lastDotIndex).toLowerCase();
                const mediaType = this.getMediaType(fileExtension);

                if (mediaType) {
                    this.$set(this.item, 'type', mediaType);
                }

            }
        },
        getMediaType(extension) {
            switch (extension) {
                case '.mp4':
                    return 'video';
                case '.mp3':
                    return 'audio';
                case '.jpg':
                case '.jpeg':
                case '.png':
                    return 'image';
                case '.pdf':
                    return 'pdf';
                default:
                    return null;
            }
        },
        isMerlinMedia(image) {
            return image.toLowerCase().includes('merlinone')
        },
    },
    mounted () {
        this.setMediaType()
    }
}
</script>
